import { makeStyles } from '@mui/styles';

const getCSSVariable = (variable) => getComputedStyle(document.documentElement).getPropertyValue(variable).trim();

export default makeStyles(() => ({

  /*COMMON NAVIGATION*/
  breadcrumbNav: {
  position: 'relative',
  '& .breadcrumb-active': {
    position: 'relative', // pour positionner le ::after
    textDecoration: 'none',
  },
  '& a:hover': {
    textDecoration: 'none',
  },
  '& .breadcrumb-active::after': {
    content: '""',
    position: 'absolute',
    left: 0,
    bottom: '0px', // distance sous le texte
    width: '100%',
    height: '2px',
    backgroundColor: getCSSVariable('--color-blue-secondary'),
  },
},

  /////////////////// INPUTS ///////////////////////
  customInputLabel: {

  },

  customInput: {
    /////// Input standard //////
    color: getCSSVariable('--color-text'),
    borderColor: getCSSVariable('--color-light-grey'),
    '& label': {
      color: getCSSVariable('--color-text'),
    },
    '& .MuiInputLabel-shrink': {
      color: getCSSVariable('--color-dark-grey'),
      backgroundColor: getCSSVariable('--color-white'),
      paddingLeft: '5px',
      paddingRight: '5px'
    },
    '&:hover label': {
      color: getCSSVariable('--color-dark-grey'),
    },
    '&:hover div': {
      color: getCSSVariable('--color-dark-grey'),
    },
    '& svg': {
      color: getCSSVariable('--color-dark-grey'),
      fontSize: 'xx-large',
    },
    '& fieldset': {
      borderRadius:'unset'
    },
    // couleur de la bordure au survol
    '&:hover fieldset': {
      borderColor: getCSSVariable('--color-blue-primary') + ' !important',
    },
    // input focus couleur
    '& .MuiOutlinedInput-root.Mui-focused fieldset': {
      borderColor: getCSSVariable('--color-blue-primary') + ' !important',
    },

    /////// Input error //////
    '& label .Mui-error':{
      color: getCSSVariable('--color-danger') + ' !important',
    },
    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: getCSSVariable('--color-danger')+ '!important',
    },
    '&:hover label .Mui-error': {
      color: getCSSVariable('--color-danger')+ '!important',
    },
    '&:hover div .Mui-error': {
      color: getCSSVariable('--color-danger') + ' !important',
    },
    '& .Mui-error fieldset':{
      color: getCSSVariable('--color-danger') + ' !important',
      borderColor: getCSSVariable('--color-danger') + ' !important',
    },
    '&:hover .Mui-error fieldset':{
      color: getCSSVariable('--color-danger') + ' !important',
      borderColor: getCSSVariable('--color-danger') + ' !important',
    },
    '&:hover .Mui-error fieldset legend':{
      color: getCSSVariable('--color-dark-grey')+ ' !important',
    },
    '&:hover fieldset .Mui-error': {
      borderColor: getCSSVariable('--color-danger') + ' !important',
    },
    '& .MuiInputLabel-shrink .Mui-error': {
      color: getCSSVariable('--color-danger'),
    },
    '&:hover .MuiInputLabel-shrink .Mui-error': {
      color: getCSSVariable('--color-danger') + ' !important',
    },
    // input focus couleur
    '& .MuiOutlinedInput-root.Mui-focused.Mui-error fieldset': {
      borderColor: getCSSVariable('--color-danger') + ' !important',
    },
    '& .MuiMenuItem-root':{
      textWrap: 'auto',
      borderBottom: '1px solid var(--color-light-grey)',
    },
    '& .small-legend .MuiOutlinedInput-notchedOutline legend ':{
      width:'42px'
    }
  },

  customListItem: {
      textWrap: 'auto !important',
      borderBottom: '1px solid var(--color-light-grey) !important',
    },

  customInputStandardSvg:{
    '& svg': {
      fontSize: 'unset',
    },
  },


  customTablePagination:{

    //Toolbar & navigation
    '& .MuiToolbar-root': {
      display: 'block',
      paddingLeft: '5px',
      paddingRight: '5px',
    },
    '& .MuiTablePagination-selectLabel': {
      float: 'left',
      padding: '4px',
      margin: '0'
    },
    '& .MuiInputBase-root': {
      float: 'left',
      margin: '0'
    },
    '& .MuiTablePagination-displayedRows': {
      width: 'fit-content',
      float: 'right',
      margin: '0'
    },
    '& .MuiTablePagination-actions': {
      width: 'fit-content',
      float: 'right',
      marginRight: '0',
      marginLeft: '0'
    },
    '& .MuiButtonBase-root':{
      backgroundColor: 'unset !important',
      padding: '0',
      marginRight: '5px',
      marginLeft: '5px'
    },
    // Results display
    '& + .MuiBox-root': {
    display: 'flex', // S'assurer que `justify-content` fonctionne
    },
  },

  customSubtitle:{
      color: `${getCSSVariable('--color-text')}`,
      textTransform: 'uppercase',
      padding:'5px',
      fontWeight: 'bold !important',
      fontSize: 'x-large !important',
  },

  customCard:{
    // borderColor: getCSSVariable('--color-light-grey'),
    border: `1px solid ${getCSSVariable('--color-light-grey')}`,
    borderTopLeftRadius: '7px !important',
    borderTopRightRadius: '7px !important',
    borderBottomLeftRadius: '0px !important',
    borderBottomRightRadius: '0px !important',
    display: 'flex',
    flexDirection: 'column',
    width: '350px',
    height: '100%',
    overflow: 'hidden',
    boxShadow: 'none !important',
    color: `${getCSSVariable('--color-text')} !important`,
    margin: '16px',

    // Un seul bloc media par breakpoint
  '@media (max-width: 900px)': {
    width: '308px',
    '& .cardTitle': {
      fontSize: '15px',
    },
    '& .cardSubtitle': {
      fontSize: 'small',
    },
    '& .actionButtonIcon': {
      fontSize: 'small',
      padding:'3px',
    },
    '& .actionButtonIcon .actionButtonText': {
      fontSize: 'small',
    },
    '& .actionButtonIcon p': {
      fontSize: 'small !important',
    },
    '& .actionButtonIcon .MuiTypography-root': {
      fontSize: 'small',
    },
    '& .actionButtonIcon svg': {
      fontSize: 'small',
    },
    '& a': {
      fontSize: 'small',
    },
    '& .expandableMenu': {
      fontSize: 'small',
    },
    '& .expandableMenu p': {
      fontSize: 'small',
    },
    '& .expandableMenu button': {
      fontSize: 'small',
    },
    '& .expandableInfos': {
      fontSize: 'small',
    },
    '& .expandableInfos p': {
      fontSize: 'small',
    },
    '& .cardActions': {
      fontSize: 'small',
    },
    '& .cardActions button': {
      fontSize: 'small',
    },
    '& .userAvatar': {
      fontSize: '4rem',
      minHeight: '100px',
      minWidth: '95px',
    },
  },

  '@media (max-width: 770px)': {
       '& .userAvatar': {
          fontSize: '4rem !important',
          minHeight: '95px !important',
          minWidth: '95px !important',
       }
    },

  '@media (max-width: 350px)': {
    width: '270px !important',
  },

  '@media (max-width: 320px)': {
    width: '250px !important',
    margin: '0 !important',
    marginTop: '16px !important',
    marginBottom: '16px !important',
  },

    '& .cardHeader':{
      display: 'flex',
      flexDirection: 'column'
    },
    '& .cardHeaderFlex':{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    },
    '& .cardTitle':{
      fontSize:'18px',
      fontWeight: 'bold',
    },
    '& .cardTitle:first-letter':{
      textTransform: 'uppercase'
    },
    '& .cardSubtitle':{
      fontSize:'15px',
    },
    '& .cardSubtitle:first-letter':{
      textTransform: 'uppercase'
    },
    '& .actionButtonIcon':{
      border: `2px solid ${getCSSVariable('--color-blue-secondary')}`,
      color: getCSSVariable('--color-blue-secondary'),
      padding: '0.4rem',
      width: 'fit-content',
      justifyItems: 'center',
      justifySelf: 'center',
      textAlign: 'center',
      cursor : 'pointer'
    },
    '& .actionButtonIcon svg':{
      color: getCSSVariable('--color-blue-secondary'),
    },
    '& .actionButtonIcon:hover':{
      color: getCSSVariable('--color-blue-primary'),
      borderColor: getCSSVariable('--color-blue-primary')
    },
    '& .actionButtonIcon:hover svg':{
      color: getCSSVariable('--color-blue-primary'),
    },
    '& a' :{
      textDecoration:'none'
    },
    '& .userAvatar':{
      width: '100%',
      maxWidth: 'fit-content',
      height: '100%', 
      minHeight: '125px',
      minWidth: '125px',
      objectFit: 'contain',
      objectPosition: 'center',
      fontSize: '5rem',
      color: 'white',
      textAlign: 'center',
      backgroundColor: getCSSVariable('--color-light-grey'),
      borderRadius: '7px',
      border: `1px solid ${getCSSVariable('--color-light-grey')}`
    },

    '& .MuiCardContent-root':{
      padding:0
      },

    '& .userAvatarWrapper':{
      justifyItems:'center',
      padding:'12px',
    },
    '& .expandableMenu':{
      display: 'flex',
      flexDirection: 'row',
      width: '85%',
      justifySelf: 'center',
      alignContent: 'center',
      alignItems: 'center',
    },
    '& .expandableMenu button':{
      padding: '0'
    },
    '& .expandableInfos': {
      paddingLeft: '1.5rem',
      paddingRight: '1.5rem',
      alignSelf: 'center'
    },
    '& .expandableInfos .large-content': {
      paddingLeft: '0',
      paddingRight: '0',
    },
    '& .cardActions':{
      alignContent: 'center',
      display: 'flex',
      justifyContent: 'space-evenly',
      flexWrap: 'wrap',
      flexDirection: 'row',
      alignItems: 'center',
    },
    '& .cardActions button':{
      marginBottom: '5px',
      marginTop: '5px'
    }
  },
  
  /**LIVE CARDS*/
  customCardVariant:{
    // borderColor: getCSSVariable('--color-light-grey'),
    border: `1px solid ${getCSSVariable('--color-light-grey')}`,
    borderTopLeftRadius: '7px !important',
    borderTopRightRadius: '7px !important',
    borderBottomLeftRadius: '0px !important',
    borderBottomRightRadius: '0px !important',
    display: 'flex',
    flexDirection: 'column',
    width: '350px',
    height: '100%',
    overflow: 'hidden',
    boxShadow: `${getCSSVariable('--box-shadow-default')} !important`,
    margin: '16px',
    color: `${getCSSVariable('--color-text')} !important`,

    '@media (max-width: 900px)': {
     width: '308px !important',
     '& .actionButtonIcon': {
      fontSize: 'small',
      padding:'3px',
    },
    '& .actionButtonIcon .actionButtonText': {
      fontSize: 'small',
    },
    '& .actionButtonIcon p': {
      fontSize: 'small !important',
    },
    '& .actionButtonIcon .MuiTypography-root': {
      fontSize: 'small',
    },
    '& .actionButtonIcon svg': {
      fontSize: 'small',
    },
    '& a': {
      fontSize: 'small',
    },
    '& .expandableMenu': {
      fontSize: 'small',
    },
    '& .expandableMenu p': {
      fontSize: 'small',
    },
    '& .expandableMenu button': {
      fontSize: 'small',
    },
    '& .expandableInfos': {
      fontSize: 'small',
    },
    '& .expandableInfos p': {
      fontSize: 'small',
    },
    '& .cardActions': {
      fontSize: 'small',
    },
    '& .cardActions button': {
      fontSize: 'small',
    },
    '& .userAvatar': {
      fontSize: '4rem',
      minHeight: '100px',
      minWidth: '95px',
    },
    },
    '@media (max-width: 768px)': {
     width: '290px !important',
    },
    '@media (max-width: 350px)': {
      width: '260px !important',
      '& .actionButtonIcon':{
        padding: '3px',
      },
    },
    '@media (max-width: 320px)': {
      width: '260px !important',
      margin: '0 !important',
      marginTop: '16px !important',
      marginBottom: '16px !important',
    },

    '& .cardHeader':{
      display: 'flex',
      flexDirection: 'column'
    },
    '& .cardHeaderFlex':{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      boxShadow: `${getCSSVariable('--box-shadow-default')} !important`,
    },
    '& .cardTitle':{
      fontSize:'18px',
      fontWeight: 'normal',
      textTransform: 'uppercase',
      color: `${getCSSVariable('--color-text')} !important`,
    },
    '& .cardSubtitle':{
      color: `${getCSSVariable('--color-dark-grey')} !important`,
      fontSize: 'smaller',
    },
    '& .actionButtonIcon':{
      border: `2px solid ${getCSSVariable('--color-blue-secondary')}`,
      color: getCSSVariable('--color-blue-secondary'),
      padding: '0.4rem',
      width: 'fit-content',
      justifyItems: 'center',
      justifySelf: 'center',
      textAlign: 'center',
      cursor : 'pointer'
    },
    '& .actionButtonIcon svg':{
      color: getCSSVariable('--color-blue-secondary'),
    },
    '& .actionButtonIcon:hover':{
      color: getCSSVariable('--color-blue-primary'),
      borderColor: getCSSVariable('--color-blue-primary')
    },
    '& .actionButtonIcon:hover svg':{
      color: getCSSVariable('--color-blue-primary'),
    },
    '& a' :{
      textDecoration:'none'
    },
    '& .cardActions':{
      alignContent: 'center',
      display: 'flex',
      justifyContent: 'space-evenly',
      flexWrap: 'wrap',
      flexDirection: 'row',
      alignItems: 'center',
    },
    '& .cardActions button':{
      marginBottom: '15px',
      marginTop: '15px'
    }
  },

    /**EXPORT CARDS BUTTON */
    actionButtonIcon:{
      border: `2px solid ${getCSSVariable('--color-blue-secondary')}`,
      color: getCSSVariable('--color-blue-secondary'),
      padding: '0.4rem',
      width: 'fit-content',
      justifyItems: 'center',
      justifySelf: 'center',
      textAlign: 'center',
      fontSize:'normal',
      '& svg':{
        fontSize:'normal',
        color: getCSSVariable('--color-blue-secondary'),
      },
      '& p':{
        fontSize:'normal',
      },
      '&:hover':{
        color: getCSSVariable('--color-blue-primary'),
        borderColor: getCSSVariable('--color-blue-primary')
      },
      '&:hover svg':{
        color: getCSSVariable('--color-blue-primary'),
      },

      '@media (max-width: 900px)': {
       fontSize:'small',
      '& svg':{
        fontSize:'small',
      },
      '& p':{
        fontSize:'small',
      },
    },

      '@media (max-width: 350px)': {
          padding: '3px',
      },


  },
  
  customTable:{

    '& .MuiTableRow-head':{
      backgroundColor: `${getCSSVariable('--color-light-grey')}`,
      borderRadius:'10px',
    },
    '& .MuiTableRow-head .MuiTableCell-head': {
      border: 'none',
    },
    '& .MuiTableRow-head .MuiTableCell-head:first-of-type': {
      borderTopLeftRadius: '10px',
      borderBottomLeftRadius: '10px',
    },
    '& .MuiTableRow-head .MuiTableCell-head:last-of-type': {
      borderTopRightRadius: '10px',
      borderBottomRightRadius: '10px',
    },
    '& .MuiTableCell-body button': {
      fontSize: 'small',
    },
    '& .no-border': {
      border: 'none',
    },
  },

  customTypoColor:{
    color: `${getCSSVariable('--color-text')} !important`,
  },

  customHoverContainer:{
    border: `1px solid ${getCSSVariable('--color-light-grey')}`,
    color: `${getCSSVariable('--color-text')} !important`,

    '&:hover':{
      borderColor: getCSSVariable('--color-blue-primary')
    },
  },

  customHoverContainerAlt:{
    border: `1px solid ${getCSSVariable('--color-light-grey')}`,
    color: `${getCSSVariable('--color-text')} !important`,
    padding: '2rem',
    borderRadius: '10px',
    textTransform: 'uppercase',
    minWidth: '145px',
    cursor: 'pointer',

    '&:hover':{
      borderColor: getCSSVariable('--color-blue-primary'),
      color: `${getCSSVariable('--color-blue-primary')} !important`,
    },
  },

  customPopup:{
    '& .MuiPaper-root':{
      backgroundColor: getCSSVariable('--color-white'),
      minWidth:'600px',
      minHeight:'600px',
      display:'flex',
      flexWrap: 'wrap',
      flexDirection: 'column',
      justifyContent: 'space-between',
      padding:'20px',
    },
    '& .MuiBox-root':{
       backgroundColor: getCSSVariable('--color-white'),
    },
    '& .popupTitle':{
      textTransform: 'uppercase',
      textAlign: 'left',
      color: getCSSVariable('--color-text')
    }
  },

  /////////////////////////////////////////////
  ////////// SMALL DEVICES DISPLAY ////////////
  /////////////////////////////////////////////


    // écrans < 900px
    '@media (max-width: 900px)': {
      customSubtitle:{
        fontSize: 'medium !important',
      },
      customTypo:{
        fontSize: 'small !important',
      },
      customInput: {
      '& span': {
        fontSize: 'small', // label dans l'input
      },
      '& label': {
        fontSize: 'small', // label dans l'input
      },
      '& input': {
        fontSize: 'small', // texte saisi
      },
      '& div': {
        fontSize: 'small', // label dans dsas custom list
      },
      '& MuiInputLabel-formControl':{
        fontSize: 'small',
      },
    },
    customInputLabel:{
      fontSize: 'small !important',
    },

    responsiveText:{
      fontSize:'small !important',
    },
  },


}));